import { graphql, StaticQuery } from "gatsby"
import React, { Component } from "react"
import constants from "../constants"
import Store from "../store"
import Actions from "../actions"
import CircledButton from "./circled-button"
import MiniSlideshow from "./mini-slideshow"
import { gsap } from "gsap"
import LanguagesButton from "./languages-button"
import NextStoryButton from "./next-story-button"
import { getLocationLanguage } from "../utils/i18n"

class Footer extends Component {
  constructor(props) {
    super(props)
    this.footer = React.createRef()
    this.menuStartPoint = undefined
    this.isMobile = undefined
    this.state = {
      menuIsOpen: false,
      isLookbookOpen: false,
      language: undefined
    }
  }
  componentDidMount() {
    this.isMobile = window.innerWidth < constants.breakpoints.lg
    this.menuStartPoint = !this.isMobile ? 74 : 80
    gsap.fromTo(this.footer.current, {y: `${100}%`, opacity: 0}, { y: `${this.menuStartPoint}%`, opacity: 1, duration: 0.6, delay: 0.8, ease: `expo.out` })
    Store.on(constants.OPEN_MENU, this.onOpen)
    Store.on(constants.CLOSE_MENU, this.onClose)
    Store.on(constants.OPEN_LOOKBOOK, this.onOpenLookbook)
    Store.on(constants.CLOSE_LOOKBOOK, this.onCloseLookbook)
    Store.on(constants.ROUTE_UPDATED, this.onRouteUpdate)
    document.addEventListener("keydown", this.onKeydown, false)
    this.setState({ language: getLocationLanguage()})
  }
  componentWillUnmount() {
    Store.off(constants.OPEN_MENU, this.onOpen)
    Store.off(constants.CLOSE_MENU, this.onClose)
    Store.off(constants.OPEN_LOOKBOOK, this.onOpenLookbook)
    Store.off(constants.CLOSE_LOOKBOOK, this.onCloseLookbook)
    Store.off(constants.ROUTE_UPDATED, this.onRouteUpdate)
    document.removeEventListener("keydown", this.onKeydown, false)
  }
  onRouteUpdate = (route) => {
    const currentLang = getLocationLanguage()
    if (route.new.indexOf(`story`) >= 0) {
      this.footer.current.style.visibility = `visible`
      if (route.old && !route.old.indexOf(`story`) >= 0) {
        gsap.fromTo(this.footer.current, {y: `${100}%`, opacity: 0}, { y: `${this.menuStartPoint}%`, opacity: 1, duration: 0.6, delay: 0.8, ease: `expo.out` })
      }
      if (route.old && route.old.indexOf(`story`) >= 0) {
        this.setState({ menuIsOpen: false })
      }
    } else {
      setTimeout(Actions.closeMenu)
      this.footer.current.style.visibility = `hidden`
    }
    if (currentLang !== this.state.language) {
      this.setState({ language: getLocationLanguage(), menuIsOpen: false })
    }
  }
  onKeydown = ({keyCode}) => {
    if (keyCode === 27) {
      setTimeout(Actions.closeMenu)
    }
  }
  onOpenLookbook = () => {
    this.setState({isLookbookOpen: true})
  }
  onCloseLookbook = () => {
    window.history.replaceState(null, Store.history.title, Store.history.url)
    if (this.isMobile) {
      gsap.to(this.footer.current, {y: `${this.menuStartPoint}%`, delay: 0.6, duration: 0.6, ease: "expo.out", onComplete: () => {
        this.setState({isLookbookOpen: false})
      }})
    } else {
      this.setState({isLookbookOpen: false})
    }
  }
  onOpen = () => {
    gsap.to(this.footer.current, {y: `0%`, duration: 0.8, opacity: 1, ease: "expo.out"})
    this.setState({menuIsOpen: true})
  }
  onClose = () => {
    gsap.to(this.footer.current, {y: `${this.menuStartPoint}%`, opacity: 1, duration: 0.6, ease: "expo.out"})
    if (this.isMobile && this.state.isLookbookOpen) gsap.to(this.footer.current, {y: `${100}%`, duration: 0.6, ease: "expo.out"})
    this.setState({menuIsOpen: false})
  }
  onTrigger = () => {
    if (this.state.menuIsOpen) setTimeout(Actions.closeMenu)
    else if (this.state.isLookbookOpen) setTimeout(Actions.closeLookbook)
    else setTimeout(Actions.openMenu)
  }
  render() {
    return (
      <StaticQuery
        query={graphql`
          query HeaderQuery {
            allMenuJson {
              nodes {
                id
                blocks {
                  asset {
                    size
                    to
                    colour
                    video {
                      duration
                      wistia {
                        en {
                          desktop
                          mobile
                        }
                        fr {
                          desktop
                          mobile
                        }
                        it {
                          desktop
                          mobile
                        }
                        pt {
                          desktop
                          mobile
                        }
                        tr {
                          desktop
                          mobile
                        }
                      }
                    }
                    download {
                      absolute
                      to
                    }
                    src {
                      childImageSharp {
                        gatsbyImageData
                      }
                    }
                  }
                  id
                }
              }
            }
          }
        `}
        render={data => {
          const menuItems = data.allMenuJson.nodes
          return (
            <footer style={{ opacity: 0, visibility: `hidden` }} ref={this.footer} className={`fixed bottom-0 right-0 z-30 w-full`}>
              <div className={`px-${constants.padmob} pb-8 lg:px-${constants.pad}`}>
                <div className={`flex justify-between lg:justify-end`}>
                  <div className={`relative h-full lg:mr-6`}>
                    <div className={`relative`}>
                      <LanguagesButton lang={this.state.language} state={this.state.menuIsOpen ? `open` : `close`} className={`bg-white text-black mr-6 hidden`} />
                      <NextStoryButton lang={this.state.language} state={this.state.menuIsOpen ? `close` : `open`} className={`text-white bg-black ml-4`} />
                    </div>
                  </div>
                  <CircledButton lang={this.state.language} onClick={this.onTrigger} state={this.state.menuIsOpen ? `minus` : this.state.isLookbookOpen ? `close` : `plus`} className={`bg-black text-white w-12 h-12 lg:w-16 lg:h-16`} />
                </div>
                <LanguagesButton lang={this.state.language} state={this.state.menuIsOpen ? `open` : `close`} className={`lg:bg-white text-black mr-6 pt-4 lg:hidden`} />
              </div>
              <div className={`w-full`}>
                <MiniSlideshow lang={this.state.language} items={menuItems} />
              </div>
            </footer>
          )
        }}
      />
    )
  }
}

export default Footer
